import axios from 'axios';
import { API_BASE_URL } from 'pages/AnyfitMall/config';

const client = axios.create({
  baseURL: `${API_BASE_URL}/api/gift`,
  headers: { 'Content-Type': 'application/json' },
});

export const giftApi = {
  // 선물 상품 조회 — GiftPurchase 진입 시 호출
  product: (token) => client.post('/product', { token }),

  // 쿠폰 등록 — 원자 트랜잭션, 성공 시 isSuccess:true
  redeem: ({ token, couponString }) =>
    client.post('/redeem', { token, couponString }),

  // 구매자 선물내역 — anyfitOrderList 선물 탭 마운트 시 호출
  history: (token) => client.post('/history', { token }),
};
